import { DataSource } from "../databinding/DataSource";
import { Event, EventListener } from "./Event";
import { ModelDataChange } from "../databinding/DataSource";

export interface DataSourceRemoteDataChangeListener extends EventListener<DataSourceRemoteDataChangeEvent> {
}

export class DataSourceRemoteDataChangeEvent extends Event<DataSource> {
    private _change: ModelDataChange;

    constructor(dataSource: DataSource, change: ModelDataChange) {
        super(dataSource, null);
        this._change = change;
    }

    public get dataSource(): DataSource {
        return this.target;
    }

    public get change(): ModelDataChange {
        return this._change;
    }
}
